import {Injectable, Optional, SkipSelf, EventEmitter} from '@angular/core';
import {Observable} from "rxjs";

/**
 * Structrure of Toast
 */
export interface ToastData {
  id: number;
  title: string;
  msg: string;
  showClose: boolean;
  type: string;
  timeout: number;
  onAdd: Function;
  onRemove: Function;
  onClick: Function;
}



@Injectable()
export class ToastService {
  private toastsEmitter: EventEmitter<ToastData> = new EventEmitter<ToastData>();
  private clearEmitter: EventEmitter<number> = new EventEmitter<number>();
  private uniqueCounter: number = 0;
   private toastsData = this.toastsEmitter.asObservable();

  constructor(@Optional() @SkipSelf() prior: ToastService) {
    if (prior) { return prior; }
  }

  getToastData():Observable<ToastData>{
    return this.toastsData
  }

  info(title: string, message: string){
    this.add(title, message, 'info');
  }
  error(title: string, message: string){
    this.add(title, message, 'error')
  }
  success(title: string, message: string){
    this.add(title, message, 'success')
  }
  warning(title: string, message: string){
    this.add(title, message, 'warning')
  }

  private add(title: string, message: string, type: string):void {
    this.uniqueCounter++;
    let toast: ToastData = <ToastData>{
      id       : this.uniqueCounter,
      title    :title,
      msg      : message,
      type     : `toasty-type-${type}`,
      theme    : 'toasty-theme-material',
      showClose: true,
      onAdd: null,
      onRemove: null,
      onClick : null,
      timeout : 1800

    };
    this.toastsEmitter.next(toast);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/toast/toast.service.ts